import React, { useState, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useOnClickOutside } from "../../hooks";
import Link from "gatsby-plugin-transition-link";

import Burger from "./Burger";
import OffCanvas from "./OffCanvas";
import ButtonSolid from "../Button/ButtonSolid";
import ButtonGhost from "../Button/ButtonGhost";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemState,
  AccordionItemPanel,
} from "react-accessible-accordion";

import phone from "../../images/Global/Nav/phone-dark-blue.svg";

const MainNav = ({ navigationStyle, scrolled, offcanvasOffset, pageType }) => {
  // determine if offcanvas is open
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  // determine button styles
  // const [buttonAltStyle, setButtonAltStyle] = useState(0);

  const [subMenuHovering1, setSubMenuHovering1] = useState(false);
  const isHoveringSubMenu1 = () => setSubMenuHovering1(true);
  const notHoveringSubMenu1 = () => setSubMenuHovering1(false);

  const [subMenuHovering2, setSubMenuHovering2] = useState(false);
  const isHoveringSubMenu2 = () => setSubMenuHovering2(true);
  const notHoveringSubMenu2 = () => setSubMenuHovering2(false);

  const [subMenuHovering3, setSubMenuHovering3] = useState(false);
  const isHoveringSubMenu3 = () => setSubMenuHovering3(true);
  const notHoveringSubMenu3 = () => setSubMenuHovering3(false);

  const [subMenuHovering4, setSubMenuHovering4] = useState(false);
  const isHoveringSubMenu4 = () => setSubMenuHovering4(true);
  const notHoveringSubMenu4 = () => setSubMenuHovering4(false);

  // handle click of navigation items
  const clickHandler = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  // close offcanvas onclick outside
  const node = useRef();
  useOnClickOutside(node, () => setOffcanvasOpen(false));

  // useEffect(() => {
  //   navigationStyle !== "overlap" && scrolled === false
  //     ? setButtonAltStyle(0)
  //     : navigationStyle === "overlap" && scrolled === false
  //     ? setButtonAltStyle(2)
  //     : setButtonAltStyle(0);
  // }, [buttonAltStyle, scrolled, navigationStyle]);

  const data = useStaticQuery(graphql`
    {
      darkLogo: file(relativePath: { eq: "Global/Nav/Logo.svg" }) {
        publicURL
      }
    }
  `);

  // Define logos based on header style
  let logo = null;

  if (navigationStyle === "overlap") {
    logo = data.darkLogo.publicURL;
  } else {
    logo = data.darkLogo.publicURL;
  }

  if (scrolled) {
    logo = data.darkLogo.publicURL;
  }

  if (offcanvasOpen) {
    logo = data.darkLogo.publicURL;
  }

  const navigation = {
    purchase: [
      {
        name: "Conventional Loans",
        href: "/conventional-home-loans/",
      },
      {
        name: "Jumbo",
        href: "/jumbo-loans/",
      },
      {
        name: "FHA Loans",
        href: "/fha-loans-pasadena/",
      },
      {
        name: "VA Loans",
        href: "/va-loans-los-angeles/",
      },
      {
        name: "DSCR/Investors",
        href: "/dscr-investor-home-loans/",
      },
      {
        name: "Non QM Loans",
        href: "/non-qm-loans/",
      },
      {
        name: "Self Employed",
        href: "/self-employed-home-loans/",
      },
      {
        name: "1031 Exchange",
        href: "/1031-loans/",
      },
   
      
    ],
    refinance: [
      {
        name: "Refinance",
        href: "/refinance-pasadena/",
      },
      {
        name: "Reverse Mortgage",
        href: "/reverse-mortgage-pasadena/",
      },
    ],
    resources: [
     // {
     //   name: "All Resources",
     //   href: "",
     // },
      {
        name: "Our Process",
        href: "/our-process/",
      },
      {
        name: "Calculators",
        href: "/mortgage-calculators/",
      },
      {
        name: "FAQs",
        href: "/faqs/",
      },
      {
        name: "Blog",
        href: "/mortgage-blog/",
      },
    ],
    about: [
      {
        name: "Company",
        href: "/about-us/",
      },
   //   {
   //     name: "Careers",
        //  href: "/mortgage-jobs/",
    //  },
     {
       name: "Reviews",
         href: "/reviews/",
     },
    ],
  };

  return (
    <nav
      id="main-navigation"
      className={`flex h-16 w-full items-center shadow-4xl transition duration-300 ease-linear md:h-20 ${
        navigationStyle === "overlap"
          ? "absolute lg:bg-transparent"
          : "lg:bg-white"
      } ${offcanvasOpen && "!bg-white"} ${
        scrolled && "!fixed top-0 left-0 z-50 w-full !bg-white"
      } `}
      role="navigation"
      aria-label="main-navigation"
    >
      <div className="container flex items-center justify-between">
        <div className="flex flex-auto items-center lg:hidden">
          <a className="" href="tel:858-215-1710">
            <img src={phone} width={28} alt="Phone icon" />
          </a>
        </div>
        <div className="flex flex-auto items-center justify-center lg:justify-start">
          <Link to="/">
            <img
              src={logo}
              alt="Accel Mortgage Logo"
              width={281}
              className="w-[191px] lg:w-[281px]"
            />
          </Link>
        </div>

        <div className="flex flex-auto items-center justify-end">
          <ul
            id="navigation-desktop"
            className="hidden md:mr-6 lg:mr-10 lg:flex lg:flex-row lg:items-center lg:justify-end lg:space-x-5 xl:space-x-8"
          >
            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu1}
              onMouseLeave={notHoveringSubMenu1}
            >
              <Link
                to="#"
                className={`relative inline pb-8 font-heading font-medium tracking-wide no-underline ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-typography-heading hover:text-primary-600"
                } ${subMenuHovering1 && "!text-primary-600"}  ${
                  scrolled && "text-typography-heading hover:text-primary-600"
                }`}
              >
                Purchase
              </Link>
              <ul
                className={`absolute top-0 z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-b-4xl border-t-2 border-primary-600 bg-white px-8 pt-3.5 pb-7 shadow-6xl transition-all duration-300 ease-linear ${
                  subMenuHovering1
                    ? "visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                }`}
              >
                {navigation.purchase.map((item, i) => {
                  return (
                    <li key={i} className="whitespace-nowrap">
                      <Link
                        to={item.href}
                        className="font-heading font-medium tracking-wide text-typography-heading no-underline hover:text-primary-600"
                      >
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>

            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu2}
              onMouseLeave={notHoveringSubMenu2}
            >
              <Link
                to="/refinance-pasadena/"
                className={`relative inline pb-8 font-heading font-medium tracking-wide no-underline ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-typography-heading hover:text-primary-600"
                } ${subMenuHovering2 && "!text-primary-600"}  ${
                  scrolled && "text-typography-heading hover:text-primary-600"
                }`}
              >
                Refinance
              </Link>
              <ul
                className={`absolute top-0 z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-b-4xl border-t-2 border-primary-600 bg-white px-8 pt-3.5 pb-7 shadow-6xl transition-all duration-300 ease-linear ${
                  subMenuHovering2
                    ? "visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                }`}
              >
                {navigation.refinance.map((item, i) => {
                  return (
                    <li key={i} className="whitespace-nowrap">
                      <Link
                        to={item.href}
                        className="font-heading font-medium tracking-wide text-typography-heading no-underline hover:text-primary-600"
                      >
                        {item.name}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </li>

            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu3}
              onMouseLeave={notHoveringSubMenu3}
            >
              <Link
                to="#"
                className={`relative inline pb-8 font-heading font-medium tracking-wide no-underline ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-typography-heading hover:text-primary-600"
                } ${subMenuHovering3 && "!text-primary-600"}  ${
                  scrolled && "text-typography-heading hover:text-primary-600"
                }`}
              >
                Resources
              </Link>
              <ul
                className={`absolute top-0 z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-b-4xl border-t-2 border-primary-600 bg-white px-8 pt-3.5 pb-7 shadow-6xl transition-all duration-300 ease-linear ${
                  subMenuHovering3
                    ? "visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                }`}
              >
                {navigation.resources.slice(1).map((item, i) => (
                  <li key={i} className="whitespace-nowrap">
                    <Link
                      to={item.href}
                      className="font-heading font-medium tracking-wide text-gray-900 no-underline hover:text-primary-600"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>

            <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu4}
              onMouseLeave={notHoveringSubMenu4}
            >
              <Link
                to="/about-us/"
                className={`relative inline pb-8 font-heading font-medium tracking-wide no-underline ${
                  navigationStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-typography-heading hover:text-primary-600"
                } ${subMenuHovering4 && "!text-primary-600"}  ${
                  scrolled && "text-typography-heading hover:text-primary-600"
                }`}
              >
                About
              </Link>
              <ul
                className={`absolute top-0 z-10 -translate-x-5 transform flex-col space-y-2.5 rounded-b-4xl border-t-2 border-primary-600 bg-white px-8 pt-3.5 pb-7 shadow-6xl transition-all duration-300 ease-linear ${
                  subMenuHovering4
                    ? "visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                }`}
              >
                {navigation.about.map((item, i) => (
                  <li key={i} className="whitespace-nowrap">
                    <Link
                      to={item.href}
                      className="font-heading font-medium tracking-wide text-gray-900 no-underline hover:text-primary-600"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          </ul>

          <div className="hidden items-center space-x-4 lg:inline-flex">
            <ButtonGhost href="/request-rates/" text="Request Rates" />
            <ButtonSolid
              href="https://markdarling.floify.com/apply-now"
              outboundLink={true}
              text="Get Pre-approved"
            />
          </div>

          <div className="lg:hidden" ref={node}>
            {/* Burger */}
            <Burger
              offcanvasOpen={offcanvasOpen}
              setOffcanvasOpen={setOffcanvasOpen}
              navigationStyle={navigationStyle}
              scrolled={scrolled}
              aria-controls="offcanvas-navigation"
            />

            {/* Mobile Nav */}
            <OffCanvas
              offcanvasOpen={offcanvasOpen}
              offcanvasOffset={offcanvasOffset}
              id="offcanvas-navigation"
            >
              <ul id="navigation-mobile" className="mb-8">
                <Accordion
                  allowZeroExpanded={true}
                  className="flex flex-col space-y-5"
                >
                  <li className="">
                    <AccordionItem uuid={1}>
                      <AccordionItemButton className="flex items-center justify-between focus:outline-none">
                        <AccordionItemState>
                          {(state) => {
                            return (
                              <>
                                <p className="mb-0 font-display font-medium uppercase tracking-wide text-primary-400 transition-colors duration-300 ease-linear hover:text-primary-400">
                                  Purchase
                                </p>

                                {/* <i
                                  className={`far ${
                                    state.expanded
                                      ? "fa-chevron-up"
                                      : "fa-chevron-down"
                                  } text-navy md:text-xl`}
                                ></i> */}
                              </>
                            );
                          }}
                        </AccordionItemState>
                      </AccordionItemButton>

                      <AccordionItemPanel className="pt-2.5">
                        <ul className="-ml-3 flex flex-col">
                          {navigation.purchase.map((item) => (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                className="relative block rounded-md bg-transparent px-4 py-1 font-medium tracking-wide text-typography-heading no-underline hover:bg-primary-100 hover:text-typography-heading"
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </li>

                  <li className="">
                    <AccordionItem uuid={2}>
                      <AccordionItemButton className="flex items-center justify-between focus:outline-none">
                        <AccordionItemState>
                          {(state) => {
                            return (
                              <>
                                <p className="mb-0 font-display font-medium uppercase tracking-wide text-primary-400 transition-colors duration-300 ease-linear hover:text-primary-400">
                                  Refinance
                                </p>

                                {/* <i
                                  className={`far ${
                                    state.expanded
                                      ? "fa-chevron-up"
                                      : "fa-chevron-down"
                                  } text-navy md:text-xl`}
                                ></i> */}
                              </>
                            );
                          }}
                        </AccordionItemState>
                      </AccordionItemButton>

                      <AccordionItemPanel className="pt-2.5">
                        <ul className="-ml-3 flex flex-col">
                          {navigation.refinance.map((item) => (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                className="relative block rounded-md bg-transparent px-4 py-1 font-medium tracking-wide text-typography-heading no-underline hover:bg-primary-100 hover:text-typography-heading"
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </li>

                  <li className="">
                    <AccordionItem uuid={3}>
                      <AccordionItemButton className="flex items-center justify-between focus:outline-none">
                        <AccordionItemState>
                          {(state) => {
                            return (
                              <>
                                <p className="mb-0 font-display font-medium uppercase tracking-wide text-primary-400 transition-colors duration-300 ease-linear hover:text-primary-400">
                                  Resources
                                </p>

                                {/* <i
                                  className={`far ${
                                    state.expanded
                                      ? "fa-chevron-up"
                                      : "fa-chevron-down"
                                  } text-navy md:text-xl`}
                                ></i> */}
                              </>
                            );
                          }}
                        </AccordionItemState>
                      </AccordionItemButton>

                      <AccordionItemPanel className="pt-2.5">
                        <ul className="-ml-3 flex flex-col">
                          {navigation.resources.map((item) => (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                onClick={clickHandler}
                                className="relative block rounded-md bg-transparent px-4 py-1 font-medium tracking-wide text-typography-heading no-underline hover:bg-primary-100 hover:text-typography-heading"
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </li>

                  <li className="">
                    <AccordionItem uuid={4}>
                      <AccordionItemButton className="flex items-center justify-between focus:outline-none">
                        <AccordionItemState>
                          {(state) => {
                            return (
                              <>
                                <p className="mb-0 font-display font-medium uppercase tracking-wide text-primary-400 transition-colors duration-300 ease-linear hover:text-primary-400">
                                  About
                                </p>

                                {/* <i
                                  className={`far ${
                                    state.expanded
                                      ? "fa-chevron-up"
                                      : "fa-chevron-down"
                                  } text-navy md:text-xl`}
                                ></i> */}
                              </>
                            );
                          }}
                        </AccordionItemState>
                      </AccordionItemButton>

                      <AccordionItemPanel className="pt-2.5">
                        <ul className="-ml-3 flex flex-col">
                          {navigation.about.map((item) => (
                            <li key={item.name}>
                              <Link
                                to={item.href}
                                onClick={clickHandler}
                                className="relative block rounded-md bg-transparent px-4 py-1 font-medium tracking-wide text-typography-heading no-underline hover:bg-primary-100 hover:text-typography-heading"
                              >
                                {item.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </li>
                </Accordion>
              </ul>
              <div className="grid space-y-4">
                <ButtonGhost
                  href="/request-rates/"
                  text="Request Rates"
                  className="w-full"
                />
                <ButtonSolid
                  href="https://markdarling.floify.com/apply-now"
                  outboundLink={true}
                  text="Get Pre-approved"
                  className="w-full"
                />
              </div>
            </OffCanvas>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default MainNav;
